import { render, staticRenderFns } from "./Draft-pelapor.vue?vue&type=template&id=fca91832"
import script from "./Draft-pelapor.vue?vue&type=script&lang=js"
export * from "./Draft-pelapor.vue?vue&type=script&lang=js"
import style0 from "./Draft-pelapor.vue?vue&type=style&index=0&id=fca91832&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports